import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import useWebSocket from "react-use-websocket";
import { loggerApi, loggerModel } from "../../entities/Logger";
import { ILogItem } from "../../entities/Logger/model";
import { message } from "antd";

export const useDeviceLogConnection = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [deviceId, setDeviceId] = useState<string>("1");
  const [connectedDeviceId, setConnectedDeviceId] = useState<string>("1");
  const [wsLoggerUrl, setWsLoggerUrl] = useState<string | null>(null);
  const dispatch = useDispatch();

  const openLogWebSocket = useCallback(
    (id: string) => {
      setWsLoggerUrl(`${process.env.REACT_APP_WS_LOGGER_URL}${id}`);
    },
    []
  );

  const closeLogWebSocket = useCallback(() => {
    setWsLoggerUrl(null);
  }, []);

  const onOpen = () => {
    dispatch(loggerModel.setIsConnected(true));
    console.log("LogWebSocket opened");
  };
  const onClose = () => {
    dispatch(loggerModel.setIsConnected(false));
    console.log("LogWebSocket closed");
  };
  const onMessage = useCallback(
    (event: WebSocketEventMap["message"]) => {
      console.log(
        "LogWebSocket onMessage event.data =",
        JSON.parse(event.data)
      );
      dispatch(loggerModel.addLog(JSON.parse(event.data)));
    },
    [dispatch]
  );

  useWebSocket(wsLoggerUrl, {
    onOpen: onOpen,
    onClose: onClose,
    onMessage: onMessage,
    shouldReconnect: (closeEvent) => true,
  });

  const connectToDevice = () => {
    setLoading(true);
    loggerApi
      .getLoggerById(deviceId)
      .then((response) => {
        console.log("response", response.data);
        dispatch(loggerModel.setLogs([]));
        setConnectedDeviceId(deviceId);
        // TODO: in future we should make pagination in our backend and load history log messages by scrolling up log page
        dispatch(loggerModel.setLogs(response.data.slice(-1000) as ILogItem[]));
        openLogWebSocket(deviceId);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteLogs = () => {
    loggerApi
      .deleteLoggerById(connectedDeviceId)
      .then(() => {
        message.success("Логи удалены");
        dispatch(loggerModel.setLogs([]));
      })
      .catch(() => {
        message.error("Не удалось удалить логи");
      });
  };
  return {
    deviceId,
    loading,
    connectToDevice,
    setDeviceId,
    deleteLogs,
    openLogWebSocket,
    closeLogWebSocket,
  };
};
